<main class="text-start">
    <h1 class="page-title"> {{ 'orders.title' | translate }} </h1>

    <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5">
        <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div class="border border-[#e0e0e0] w-full sm:w-72 rounded-lg overflow-hidden flex">
                <span class="bg-white py-[7.5px] ps-2.5">
                    <i class="bi bi-search text-sm"></i>
                </span>
                <input type="text"
                    class=" bg-white py-[8px] px-4 w-full text-start focus:outline-none focus:border-black text-xs"
                    [placeholder]="'orders.search_placeholder' | translate" (input)="onSearchChange($event)">
            </div>
            <div class="max-sm:w-full flex max-sm:justify-start gap-2">
                <app-filters-dropdown
                    [filters]="orderFilters"
                    [ngModel]="filterValues"
                    (ngModelChange)="onFiltersChange($event)"
                    [lang]="languageService.currentLang()"
                />
                <button app-export-excel-button class="ms-3 hidden sm:inline-flex"
                    [disabled]="isExporting"
                    (click)="onExportExcel()"></button>
            </div>
        </div>

        <div class="overflow-x-auto">
            <app-filtering-chips [options]="statusFilters" (onFilter)="getOrders($event)" />
        </div>

        <div class="w-full bg-white rounded-xl px-5 py-5 mt-3">
            <div class="overflow-x-auto">

                <table class="generic-table">
                    <thead>
                        <tr>
                            <th>{{ 'orders.table.uuid' | translate }}</th>
                            <th>{{ 'orders.table.name' | translate }}</th>
                            <th>{{ 'orders.table.status' | translate }}</th>
                            <th>{{ 'orders.table.placed_at' | translate }}</th>
                            <th>{{ 'orders.table.total' | translate }}</th>
                            <th> {{ 'orders.table.items_count' | translate }} </th>
                            <th>{{ 'orders.table.details' | translate }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!ordersResponse">
                            <tr *ngFor="let _ of [1,2,3,4,5,6,7]" app-table-skeleton-row [columns]="8"></tr>
                        </ng-container>
                        <tr *ngFor="let order of ordersResponse?.results" [routerLink]="['/orders', order.order_uuid]"
                            class="cursor-pointer">
                            <td class="p-3 text-gray-600">#{{ order.order_uuid | slice:0:8 }}</td>
                            <td>
                                <div class="flex justify-start items-center gap-2">
                                    <div class="bg-[#FCC5F3] w-6 h-6 rounded-full">
                                        <img src="dashboard/place-holders/avatar-female.png" class="w-6 h-6 rounded-full"
                                            alt="">
                                    </div>
                                    <span>{{ order.name }}</span>
                                </div>
                            </td>
                            <td>
                                <span [ngClass]="{
                                        'bg-purple-100 text-purple-700': order.status === 'preparing_order',
                                        'bg-blue-100 text-blue-700': order.status === 'placed',
                                        'bg-emerald-100 text-emerald-700': order.status === 'ready_for_pickup',
                                        'bg-yellow-100 text-yellow-700': order.status === 'out_for_delivery',
                                        'bg-green-100 text-green-700': order.status === 'delivered',
                                        'bg-red-100 text-red-700': order.status === 'cancelled' || order.status === 'rejected',
                                        'bg-rose-100 text-rose-700': order.status === 'refunded'
                                        }" class="status-chip">
                                    {{ ('orders.statuses.' + order.status) | translate }}
                                </span>
                            </td>
                            <td><span dir="ltr" class="inline-block">{{ order.placed_at | date: 'dd MMM / hh:mm a' }}</span></td>
                            <td>{{ order.total_price }} {{ 'common.currency' | translate }}</td>
                            <td> {{ order.items.length }} </td>
                            <td>
                                <div class="flex items-center justify-start gap-1">
                                    <img *ngFor="let item of order.items" [src]="item.variant.images[0].image"
                                        class="w-6 h-6 rounded" alt="">
                                </div>
                            </td>
                            <td>
                                <i class="bi" [ngClass]="languageService.isRtl() ? 'bi-arrow-left-circle' : 'bi-arrow-right-circle'"></i>
                            </td>
                        </tr>
                        <tr *ngIf="ordersResponse?.count == 0" class="cursor-pointer">
                            <td colspan="100%" class="text-start">{{ 'orders.empty' | translate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <app-table-pagination *ngIf="ordersResponse" [count]="ordersResponse.count" [limit]="pagination.limit" [offset]="pagination.offset"
                (pageChange)="updatePagination($event)" />
        </div>
    </div>

</main>
